import React, { useState } from 'react';
import { PDFDownloadLink, pdf } from '@react-pdf/renderer';
import MyPDFDocument from './daArrearsPurePDF';

// Utility function to format date as dd/mm/yyyy
const formatDate = (date) => {
  const d = new Date(date);
  const day = String(d.getDate()).padStart(2, '0');
  const month = String(d.getMonth() + 1).padStart(2, '0'); // Months are zero-based
  const year = d.getFullYear();
  return `${day}/${month}/${year}`;
};

// Function to format the file name as needed
const formatFileName = (employeeName) => {
  const formattedDate = formatDate(new Date());
  return `DA_Arrears_${employeeName}_${formattedDate}.pdf`;
};

const InteractivePDFWrapper = ({ result, info }) => {
  const [isLoading, setIsLoading] = useState(false);

  const openPDFInNewTab = async () => {
    setIsLoading(true);
    const asPdf = pdf(<MyPDFDocument result={result} info={info} />);
    const blob = await asPdf.toBlob();
    const blobUrl = URL.createObjectURL(blob);
    window.open(blobUrl, '_blank');
    setIsLoading(false);
  };

  return (
    <div className="text-center my-8">
      {/* Button Wrapper for Horizontal Layout */}
      <div className="flex justify-center gap-6 mt-4">
        <PDFDownloadLink
          document={<MyPDFDocument result={result} info={info} />}
          fileName={formatFileName(info.employeeName)}
          style={{ textDecoration: 'none' }}
        >
          {({ loading }) =>
            loading ? (
              <button
                disabled
                className="px-6 py-2 text-lg font-bold border-2 border-gray-300 bg-gray-200 text-gray-500 rounded-md cursor-not-allowed"
              >
                Loading document...
              </button>
            ) : (
              <button
                className="px-6 py-2 text-lg font-bold border-2 border-green-500 bg-green-500 text-white rounded-md hover:bg-green-600 transition-all"
              >
                Download PDF
              </button>
            )
          }
        </PDFDownloadLink>

        <button
          onClick={openPDFInNewTab}
          className="px-6 py-2 text-lg font-bold border-2 border-green-500 bg-green-500 text-white rounded-md hover:bg-green-600 transition-all"
        >
          View in New Tab
        </button>
      </div>
    </div>
  );
};

export default InteractivePDFWrapper;
